/**
 * One-shot handoff: "open the call-back ladder on THIS day".
 *
 * The ladder ("Short · options", `<ShortfallOptionsModal/>`) is THE path
 * for covering a day — it is mounted inside the roster grid and owns a
 * local `shortfallDate` state, opened by the day header's own chip. The
 * "Review cover" chip, on the workspace toolbar, is the INBOX of MCs
 * whose seats nobody has covered yet; clicking an item must land the lead
 * on that day's ladder rather than on a second, parallel remedy.
 *
 * The chip and the grid have no common ancestor holding that state (the
 * chip sits in `<CycleWorkspaceShell/>`'s toolbar, the modal inside
 * `<RosterHeatmap/>` / `<MobileRosterView/>`), and a date does not belong
 * in the `?surface=` deep-link. So a tiny zustand store carries the pair
 * across: the grid CONSUMES the request on arrival and clears it — one-shot, so
 * closing the modal never re-opens it.
 *
 * `cycleId` is carried so a grid for a DIFFERENT cycle (a stale mount, a
 * quick hop between cycles) ignores a request that wasn't meant for it.
 */
import { create } from "zustand";

export interface ShortfallOpenRequest {
  cycleId: string;
  /** ISO yyyy-mm-dd — the day whose ladder should open. */
  date: string;
}

interface ShortfallOpenRequestState {
  request: ShortfallOpenRequest | null;
  requestShortfallOptions: (r: ShortfallOpenRequest) => void;
  clearShortfallOpenRequest: () => void;
}

export const useShortfallOpenRequestStore = create<ShortfallOpenRequestState>((set) => ({
  request: null,
  requestShortfallOptions: (r) => set({ request: r }),
  clearShortfallOpenRequest: () => set({ request: null }),
}));
